const qiniuUrl = 'http://qn.saiday.com/'
const yoyoCommonServer = '//qncommon.saiday.com'

function qiniuImage(key, width, height) {
  const imageView = (width && height) ? `?imageView2/0/w/${width}/h/${height}` : ''
  return `${qiniuUrl}${key}${imageView}`
}

module.exports = {
  qiniuUrl,
  qiniuImage,
  yoyoCommonServer,
}



// WEBPACK FOOTER //
// ./client/utils/qiniu.js